import { Temporal } from '@imago/api-client'
import { type HTML } from './documents/_HTML.ts'
import { GAHTSetupCall_ID, GAHTTransferCall_ID, WelcomeCall_ID } from './documents/Report.ts'
import { GAHTOnboarding_ID, type ProductID, type ProductInfo, type ServiceID, type ServiceInfo, type ServiceOrProductInfo } from './documents/ServiceProduct.ts'

export const TEMPORARILY_HERE_productsAndServices: ServiceOrProductInfo[] = [
	{
		ID: WelcomeCall_ID,
		title: 'Welcome call',
		duration: Temporal.Duration.from({minutes: 15}),
		freezeTime: Temporal.Duration.from({hours: 24}),
	},
	{
		ID: GAHTOnboarding_ID,
		title: 'GAHT onboarding',
		price: '€250',
	},
	{
		ID: GAHTSetupCall_ID,
		title: 'GAHT setup call',
		duration: Temporal.Duration.from({minutes: 45}),
		freezeTime: Temporal.Duration.from({hours: 24}),
	},
	{
		ID: GAHTTransferCall_ID,
		title: 'GAHT transfer call',
		duration: Temporal.Duration.from({minutes: 15}),
		freezeTime: Temporal.Duration.from({hours: 24}),
	},
	{
		ID: 'imago.services.mental-health-counselling-amanda' as ServiceID & ProductID,
		title: 'Mental health counselling (with Amanda, for under 18s)',
		duration: Temporal.Duration.from({minutes: 60}),
		freezeTime: Temporal.Duration.from({hours: 24}),
		price: '€60',
		description: `<p>Tame the demons tormenting your psyche.</p>` as HTML,
		bio: `<p><b>Amanda Comet</b> (she/her) has a broad experience in psychiatry, giving counselling for suicidal ideation, trauma, substance abuse, and personality syndromes as well as everyday challenges related to executive dysfunction, anxiety, ADHD, and autism. Together with you, she will develop tools and strategies to navigate your issues as well as stabilize and improve your mental wellbeing. Amanda is fluent in Swedish and English and have life experience as a transperson with a visual disability. <a href="https://www.imago.tg/blog/introducing-imago-s-mental-health-support/">Read Amanda’s letter of introduction</a></p>` as HTML,
	},
	{
		ID: 'imago.services.mental-health-counselling' as ServiceID & ProductID,
		title: 'Mental health counselling (with Rhea)',
		duration: Temporal.Duration.from({minutes: 60}),
		freezeTime: Temporal.Duration.from({hours: 24}),
		price: '€85',
		description: `<p>Reclaim the agency to shape your own way forward.</p>` as HTML,
		bio: `<p><b>Rhea</b> (she/her) is an integrative, person-centred psychotherapist who favours an existential-humanistic approach. In her experience – the power and agency of the individual to instigate change is often overlooked, which is where the development of a greater self-awareness is also central to the therapeutic process.<br/><br/>Rhea is a transgender woman, and strives to normalise and educate on the spectrums of gender identity and sexuality.<br/><br/>She believes that a non-judgemental, empathic environment is paramount, in order for real change to begin; and, after that, the path towards living your best life becomes a more realistic possibility.</p>` as HTML,
	},
	{
		ID: 'imago.services.vocal-coaching' as ServiceID & ProductID,
		title: 'Vocal coaching',
		duration: Temporal.Duration.from({minutes: 50}),
		freezeTime: Temporal.Duration.from({hours: 24}),
		price: '€65',
		description: `<p>Find your authentic voice and vocal autonomy with our vocal dysphoria coach!</p>` as HTML,
		bio: '<p><b>Mateo Milicevic</b> (he/him) is a voice and communication coach offering gender-affirming voice work — voice feminization and masculinization — alongside therapy for functional voice issues such as vocal nodules. His background is in Clinical Phonetics and Applied Linguistics, and his master’s thesis, a case study on voice therapy with a trans woman, became the first peer-reviewed paper of its kind in a Croatian speech sciences journal. His approach is highly individualized and built around self-listening: getting you tuned in to how your own voice works, sounds, and feels, so that once you can hear it, you can change it. He is also involved with a Croatian NGO working on trans rights.</p>' as HTML,
	},
	{
		ID: 'imago.services.fertility-counselling' as ServiceID & ProductID,
		title: 'Fertility counselling',
		duration: Temporal.Duration.from({minutes: 40}),
		freezeTime: Temporal.Duration.from({hours: 24}),
		price: '€50',
		description: `<p>Do you need advice regarding GAHT’s effect on fertility, perhaps you want to store your gametes?</p>` as HTML,
	},
]

export const TEMPORARILY_HERE_advertisedServices = TEMPORARILY_HERE_productsAndServices.filter(service => service.ID === 'imago.services.mental-health-counselling' || service.ID === 'imago.services.vocal-coaching') as (ServiceInfo & ProductInfo)[]

const TestUserTemplateID__Brand: unique symbol = Symbol()
export type TestUserTemplateID = string & {[TestUserTemplateID__Brand]: never}

export interface TestUserTemplateInfo {
	ID: TestUserTemplateID
	shortName: string
	description: string
}

export const TEMPORARILY_HERE_testUserTemplates: TestUserTemplateInfo[] = [
	{
		ID: 'adam' as TestUserTemplateID,
		shortName: "Adam",
		description: "a new user",
	},
	{
		ID: 'eve' as TestUserTemplateID,
		shortName: "Eve",
		description: "an onboarding user",
	},
	{
		ID: 'kasia' as TestUserTemplateID,
		shortName: "Kasia",
		description: "a greenlighted user",
	},
	{
		ID: 'beata' as TestUserTemplateID,
		shortName: "Beata",
		description: "a long-time user",
	},
]
